<div class="btn-group">
  <button mat-button  (click)="markAsRead()">{{"DONE_OR_DETAILS.MARK" | translate}}</button>
  <button mat-button cdkFocusInitial (click)="details()">{{"DONE_OR_DETAILS.DETAILS" | translate}}</button>
  <button mat-button (click)="close()">{{"DONE_OR_DETAILS.BACK" | translate}}</button>
</div>
